
import { Link, useLocation } from 'react-router-dom';

export default function MobileBottomNav() {
  const location = useLocation();
  const currentPath = location.pathname;

const navItems = [
  { label: "Home", icon: "ri-home-5-line", activeIcon: "ri-home-5-fill", path: "/home" },
  { label: "Wallet", icon: "ri-wallet-3-line", activeIcon: "ri-wallet-3-fill", path: "/wallet" },
  { label: "Bills", icon: "ri-bill-line", activeIcon: "ri-bill-fill", path: "/bills" },
  { label: "Reward", icon: "ri-gift-line", activeIcon: "ri-gift-line", path: "/reward" },
  { label: "Profile", icon: "ri-user-line", activeIcon: "ri-user-fill", path: "/profile" },
];

  return (
   <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-slate-100 z-50">
      <div className="flex items-center justify-around px-4 py-3 max-w-md mx-auto">
        {navItems.map((item) => {
          const isActive = currentPath === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center justify-center flex-1 py-2 cursor-pointer transition-colors ${
                isActive ? 'text-navy-600' : 'text-gray-500'
              }`}
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`${isActive ? item.activeIcon : item.icon} text-xl`}></i>
              </div>
              <span className={`text-xs mt-1 ${isActive ? 'font-medium' : ''}`}>{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
